
import { useContext, useEffect } from 'react'
import MapContext from '../Map/MapContext'

import { layerVector } from './_layerGeojson';
import { layerWMTS } from './_layerWMTS';
import { layerWMS } from './_layerWMS';
import { layerTile } from './_layerXYZ_OSM';
import { layerEmpty } from './_layerEmpty';

import { addZoomToClusterEvent } from './_layerGeojson';

/**
 * Función para añadir capas al mapa según el tipo de fuente
 * @param {*} props 
 * @returns null
 */
function Layer(props) {

    const {
        source,
        name,
        title,
        url,
        params = null,
        zIndex,
        cluster = null,
        iconColor = 'black',
        category = null,
        iconPath = null,
        visible = false,
        queryable,
        minZoom = null,
        maxZoom = null,
        attributions = null
    } = props;
    const { map } = useContext(MapContext)
    let tileLayer = null

    /**
     * Efecto para añadir capa al mapa
     */
    useEffect(() => {
        if (!map) return

        // si es geojson utilizamos funcion layerVector, sino layerTile para obtener la capa
        if (source === 'geojson') {
            tileLayer = layerVector({ title, url, params, cluster, iconColor, map, category, iconPath, visible, queryable, minZoom, maxZoom, attributions })
        } else if (source === 'ol' && name === 'empty') {
            // Capa vacía/transparente (sin mapa base)
            tileLayer = layerEmpty(props)
        } else if (source === 'olSource' || source === 'xyz') {
            tileLayer = layerTile(props)
        } else if (source === 'wms') {
            tileLayer = layerWMS(props)
        } else if (source === 'wmts') {
            // console.log('Adding WMTS layer ', name);
            tileLayer = layerWMTS(props)
        }

        // si tileLayer es nulo, no se añade la capa
        if (tileLayer) {
            tileLayer.set('visible', visible);
            map.addLayer(tileLayer);
            tileLayer.set('name', name);

            // Si zIndex está definido, establecemos el zIndex de la capa Z-INDEX
            if (zIndex !== null) {
                tileLayer.setZIndex(zIndex);
            }

            // añadimos el evento zoom sobre el cluster
            addZoomToClusterEvent(map, tileLayer, cluster)

            // console.log('Tile layer añadida:', name, responseInfoFormat, title);
        }

        // desmontar capa y listener
        return () => {
            if (map && tileLayer) {
                map.removeLayer(tileLayer);
            }
        };
    }, [map, tileLayer])

    return null
}

export default Layer